import { type RefObject, useCallback, useEffect, useState } from 'react';
import { type ViewInstance } from 'react-native';

export const useHovered = (ref: RefObject<ViewInstance | HTMLElement | null>) => {
  const [isHovered, setHovered] = useState(false);

  const onHoverIn = useCallback(() => {
    setHovered(true);
  }, []);

  const onHoverOut = useCallback(() => {
    setHovered(false);
  }, []);

  useEffect(() => {
    const node = ref.current as HTMLElement | null;

    node?.addEventListener?.('mouseenter', onHoverIn);
    node?.addEventListener?.('mouseleave', onHoverOut);

    return () => {
      node?.removeEventListener?.('mouseenter', onHoverIn);
      node?.removeEventListener?.('mouseleave', onHoverOut);
    };
  }, [ref, onHoverIn, onHoverOut]);

  return isHovered;
};
